// extracted by mini-css-extract-plugin
export default {"dateField":"MyForms__dateField___1_Hyt","date":"MyForms__date___DUF1q","time":"MyForms__time___2tiuz"};